import React, { useEffect, useState } from "react"
import { useSearchParams  } from 'react-router-dom';
import $ from "jquery"
import "./Detalhes.css"
//import { CCarousel, CCarouselCaption, CCarouselItem, CImage } from '@coreui/react'
import HTML from 'html-react-parser';
import CarouselB2Z from "../../Componentes/CarouselB2Z/CarouselB2Z.js";
import { LocalData } from "../../Componentes/Util/LocalData"
import { ChevronLeft, Heart, HeartFill } from 'react-bootstrap-icons';
import CaminhoRato from "../../Componentes/Cabecalho/CaminhoRato.js";
import RodapePaginaSuspensa from "../../Componentes/Rodape/RodapePaginaSuspensa.js";

const DetalhesProduto = ({Lista, AtualizaContador, ldPROD}) => {
    const [searchParams, setSearchParams] = useSearchParams();
    //let { idCategoria } = useParams();
    const [indexBanner, setIndexBanner] = useState(0);
    const [localdataPROD, setLocaldataPROD] = useState();

      useEffect(() => {
         const fetchProduto = async () => {
            //setLocaldataPROD(ldPROD);
            try{
                if(LocalData.get("prodID") !== "")
                    setLocaldataPROD(JSON.parse(LocalData.get("prodID")));
            }catch(e){}
            setIndexBanner(0);
         }
         fetchProduto();
    }, [Lista]);    
    
    const evFecharDetalheProduto = () => {
        $(".area-produto").removeClass("produto-selecionado");
        $(".area-impressao-produto").removeClass("selecionado");

        $("body").removeClass("overflow-hidden");
        $("#bannerCarousel .carousel-indicators button:first-child").trigger("click");
        //setIndexBanner(0);
        //$("#bannerCarousel .carousel-inner .carousel-item").removeClass("active");
        
        // Define o novo valor para o parâmetro 'filtro'
        searchParams.delete('idprod');        
        // Atualiza a URL sem recarregar a página
        setSearchParams(searchParams); 
    }
    $(".area-produto").off().on("transitionend", myEndFunction);
    function myEndFunction(e) {      
        // if(!$(e.currentTarget).hasClass("produto-selecionado"))
        //     console.log("fim da animação");

        // if(!$(e.currentTarget).hasClass("produto-selecionado"))
        //     $(".area-produto > .conteudo").html("");
    }

    const handleSelect = (selectedIndex) => {
        setIndexBanner(selectedIndex);
        //alert(selectedIndex);
    };  
    // const teste =()=>{
    //     $("#carouselExampleIndicators").carousel('1');
    //}
    // const myCarousel = document.getElementById('carouselExampleIndicators')
    // myCarousel.addEventListener('slide.coreui.carousel', event => {
    // // do something...
    //     alert("teste");
    // })
    // $('#carouselExampleIndicators').on('slide.bs.carousel', function () {
    //     // do something…
    //     alert("TETSE");
    //   })

    //$("#bannerCarousel").trigger("onSlide");
    //$("#bannerCarousel .carousel-inner .carousel-item:first-child").addClass("active");

    //$("#bannerCarousel .carousel-indicators button:first-child").trigger("click");
    //console.log(indexBanner);
    
    const evCliqueEnviarParaLista = (e) => {
        e.preventDefault();
        e.stopPropagation();
        //alert(JSON.parse(LocalData.get("prodID")));
        //console.log(localdataPROD, LocalData.get("prodID"), Lista[0].identificador);
         let index = -1;
         let arrNovo, arr = [];
  
         try{
           if(LocalData.get("prodID") !== ""){
             index = JSON.parse(LocalData.get("prodID")).findIndex(val => val == parseInt(Lista[0].identificador));
             arr = JSON.parse(LocalData.get("prodID"));            
           }
         }catch(error){}
  
         arrNovo = parseInt(Lista[0].identificador);
        // //alert(arrNovo);
  
         if($(`.vitrine .lista-produtos-categoria [id=${Lista[0].identificador}]`).find(".eu-quero-produto").hasClass("marcado")){
           arr = arr.filter(num => num !== parseInt(Lista[0].identificador));
           $(`.vitrine .lista-produtos-categoria [id=${Lista[0].identificador}]`).find(".eu-quero-produto").removeClass("marcado");
           $(e.currentTarget).removeClass("marcado");
           $(e.currentTarget).find("span").html("Incluir no catálogo");
           //alert($(e.currentTarget).hasClass("marcado"));
        } else if(index == -1 && !$(`.vitrine .lista-produtos-categoria [id=${Lista[0].identificador}]`).find(".eu-quero-produto").hasClass("marcado")){
           arr.push(arrNovo);
           $(`.vitrine .lista-produtos-categoria [id=${Lista[0].identificador}]`).find(".eu-quero-produto").addClass("marcado");
           $(e.currentTarget).addClass("marcado");
           $(e.currentTarget).find("span").html("Excluir no catálogo");
           //alert($(e.currentTarget).hasClass("marcado"));
         }
         //console.log(arr);
         $(".lista-de-desejos .contador").html(arr.length);
         //console.log(arr);
         //setLocaldataPROD(arr);
         LocalData.set("prodID", JSON.stringify(arr));

         AtualizaContador(arr);
    }

    // function AtualizaContador(lista){
    // if(lista.length > 0) {
    //     $(".lista-de-desejos").addClass("marcador");
    // } else {
    //     $(".lista-de-desejos").removeClass("marcador");    
    // }      
    // $(".lista-de-desejos .contador").html(lista.length);
    // }
    //console.log("##", localdataPROD, localdataPROD.filter((a) => a == parseInt(Lista[0].identificador)).length, parseInt(Lista[0].identificador));
    try{
        if(localdataPROD.filter((a) => a == parseInt(Lista[0].identificador)).length > 0)
            $(".area-produto .detalhe-produto .eu-quero-produto").addClass("marcado");
        else
            $(".area-produto .detalhe-produto .eu-quero-produto").removeClass("marcado");
    }catch(error){}

    return (
        <div className="area-produto">
        <div className="btn-fechar-detalhe-produto" onClick={evFecharDetalheProduto}>X</div>
        {            
            Lista.map((a, index) => (
            <div key={index} className="conteudo detalhe-produto">
                <div>
                    <CarouselB2Z lista={JSON.parse(a.dados).anexos} width={"400px"} height={"400px"} />
                </div>
                <div className="descricao-produto">
                    <div className="area-caminho-rato">
                        <div className="btn-voltar-caminho-rato" onClick={evFecharDetalheProduto}><ChevronLeft size={12} /> Voltar</div>
                        <h3><CaminhoRato caminho={JSON.parse(a.dados).arvoreCategoria[JSON.parse(a.dados).arvoreCategoria.length-1].descricaoCompleta} divisor={">"} /></h3>
                    </div>
                    <h3>{JSON.parse(a.dados).nome}</h3>
                    <span>{HTML(JSON.parse(a.dados).descricaoComplementar)}</span>
                    <div className="eu-quero-produto" onClick={evCliqueEnviarParaLista}>
                        {/* <Heart size={24}></Heart> */}
                        <HeartFill title="Incluir no catálogo" size={24}></HeartFill>
                        <span>{localdataPROD && (localdataPROD.filter((a) => a == parseInt(Lista[0].identificador)).length > 0) ? "Excluir no catálogo" : "Incluir no catálogo"}</span>
                    </div>
                </div>
            </div>
            ))
            //console.log(Prod.dados)
        }
        <RodapePaginaSuspensa></RodapePaginaSuspensa>
        </div>
    )
}

export default DetalhesProduto;